import React, {Component} from "react";

class CircleMemberTableRow extends Component {


    startCircleMemberEdit() {
        let {start_circle_member_edit, circle_member} = this.props;


        start_circle_member_edit(circle_member);
    }

    render() {
        let {circle_member} = this.props;

        if (!circle_member.last_active) {
            circle_member.last_active = "N/A";
        }

        return (
            <tr className='circle_member_row'>
                <td className='circle_member_td'>{circle_member.first_name + " " +  circle_member.last_name}</td>
                <td className='circle_member_td'>{circle_member.email}</td> 
                <td className='circle_member_td'>{circle_member.relationship_to_user}</td>  
                <td className='circle_member_td'>{circle_member.last_active}</td>  
                <td className='circle_member_td edit_circle_member' onClick={this.startCircleMemberEdit.bind(this)}>Edit</td> 
            </tr>
        )
    }

    
}

export default CircleMemberTableRow;


// WEBPACK FOOTER //
// ./src/components/containers/home-play/circle-members/circle-member-table-row.js